<template>
  <div>
    <v-dialog v-model="dialog_consumer_unit" persistent max-width="1000px">
      <v-card color="#FFF">
        <CustomerFormUnit />
        <v-layout pa-2>
          <v-spacer />
          <v-btn dark color="blue" @click="dialog_consumer_unit = false"
            >Fechar</v-btn
          >
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { eventBus } from "../../main";
import CustomerFormUnit from "../customer/CustomerFormUnit";
export default {
  created() {
    // console.log('created ConsumerUnitForm')
    var vm = this;
    eventBus.$on("dialog_consumer_unit", function (value) {
      vm.dialog_consumer_unit = value;
    });
  },
  components: {
    CustomerFormUnit,
  },
  data: function () {
    return {
      dialog_consumer_unit: false,
    };
  },
};
</script>
